import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as Global from 'src/app/global';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { passwordConfirmationValidator } from 'src/app/validators/custom-form.validator';

@Component({
    selector: 'app-singup',
    templateUrl: './singup.component.html',
    styleUrls: ['./singup.component.css']
})

export class SingupComponent implements OnInit {
    Global = Global;
    roleMaster: any[];
    registerForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private toastr: ToastrService,
        private router: Router,
    ) {
        this.registerForm = formBuilder.group(
            {
                role: [null, Validators.compose([Validators.required])],
                name: [null, Validators.compose([Validators.required])],
                email: [null, Validators.compose([Validators.required, Validators.email])],
                mobile: [null, Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)])],
                password: [null, Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(20)])],
                password_confirmation: [null, Validators.compose([Validators.required, passwordConfirmationValidator("password")])],
                company_info: formBuilder.group({
                    company_name: [null, Validators.compose([Validators.required])],
                    company_phone: [null, Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)])],
                    company_address: [null, Validators.compose([Validators.required])],
                    company_pincode: [null, Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(6), Validators.maxLength(6)])],
                    company_pan_no: [null],
                    company_gst_no: [null],
                }),
                accept_terms: [null, Validators.compose([Validators.requiredTrue])],
            }
        );

        this.roleMaster = [
            { label: "Seller", value: "seller" },
            { label: "Facilator", value: "broker" },
            { label: "Buyer", value: "buyer" },
        ];
        this.registerForm.get('role')?.valueChanges.subscribe((role)=>{
        if(role=='seller')
        {
          this.router.navigateByUrl('seller/onboard');
        }
        })

        // this.registerForm.patchValue({
        //     "role": "buyer",
        //     "name": "Jimmy Doe",
        //     "email": "jimmy.doe@yopmail.com",
        //     "mobile": "7884561231",
        //     "password": "12345678",
        //     "password_confirmation": "12345678",
        //     "company_info": {
        //         "company_name": "Ivan Infotech",
        //         "company_phone": "9876541230",
        //         "company_address": "Kolkata, West Bengal",
        //         "company_pincode": "700109",
        //         "company_pan_no": "ABCDE1234G",
        //         "company_gst_no": "22AAAAA0000A1Z5"
        //     }
        // })
    }

    ngOnInit(): void {

    }

    submit(event: any) {
        this.registerForm.markAllAsTouched();
        Global.scrollToQuery(".form-control.is-invalid");

        if (this.registerForm.valid) {
            event.target.classList.add('btn-loading');
            event.target.disabled = true;

            this.authService.userRegister({
                'role': this.registerForm.value.role ?? null,
                'name': this.registerForm.value.name ?? null,
                'email': this.registerForm.value.email ?? null,
                'mobile': this.registerForm.value.mobile ?? null,
                'password': this.registerForm.value.password ?? null,
                'password_confirmation': this.registerForm.value.password_confirmation ?? null,
                'company_info': {
                    'company_name': this.registerForm.value.company_info.company_name ?? null,
                    'company_phone': this.registerForm.value.company_info.company_phone ?? null,
                    'company_address': this.registerForm.value.company_info.company_address ?? null,
                    'company_pincode': this.registerForm.value.company_info.company_pincode ?? null,
                    'company_pan_no': this.registerForm.value.company_info.company_pan_no ?? null,
                    'company_gst_no': this.registerForm.value.company_info.company_gst_no ?? null,
                }
            }).subscribe(res => {
                const data = res.data;
                if (res.status == 'success') {
                    this.authService.userSuccessLogin({
                        'token': data?.token ?? null,
                        'user': data?.user ?? null,
                    })
                } else if (res.status == 'otpverification') {
                    this.router.navigate([`/otp-verification/user-register/${res.data.token}`]);
                    this.toastr.success(res.message)
                } else if (res.status == 'val_error') {
                    this.toastr.error(Global.getValidationMessage(data?.errors ?? []));
                } else {
                    this.toastr.error(res.message);
                }

                event.target.classList.remove('btn-loading');
                event.target.disabled = false;
            }, err => {
                //this.toastr.error(Global.getServerErrorMessage(err));

                event.target.classList.remove('btn-loading');
                event.target.disabled = false;
            });
        }
    }
}
